/* Copyright (c) 2020-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

/* eslint-disable @typescript-eslint/naming-convention */
// TODO: refactor to PascalCase
enum ACTIONS_VISIT {
  visitAccounts = "visit:accounts",
  visitAccountDetails = "visit:account-details",

  visitApplications = "visit:applications",
  visitApplicationAdd = "visit:application-add",
  visitApplicationDetails = "visit:application-details",
  visitCostAnalysis = "visit:cost-analysis",

  visitReservations = "visit:reservations",

  visitDashboard = "visit:dashboard",
  visitHomepage = "visit:homepage",

  visitEstateRecords = "visit:estate-records",
  visitEstateRecordsDetails = "visit:estate-details",

  visitCostSplittingRules = "visit:cost-splitting-rules",

  visitUsersPermissions = "visit:users-permissions",

  visitGlobalApiKeys = "visit:global-api-keys",

  visitArchive = "visit:archive",

  visitNotifications = "visit:notifications",

  visitExport = "visit:export-page",

  visitEnvironmentDetails = "visit:environment-details",

  visitDriftReport = "visit:drift-report",

  visitExternalIntegrations = "visit:external-integrations",

  visitSearchResults = "visit:search-results",

  visitMapping = "visit:mappings",

  visitSettings = "visit:settings",
  visitEmployees = "visit:employees",

  visitOrgUnitTypes = "visit:org-unit-types",

  visitBusinessContexts = "visit:business-contexts",
  visitBusinessContextDetails = "visit:business-context-details",
  visitBusinessContextStructure = "visit:business-context-structure",

  visitReleaseNotes = "visit:release-notes",
  visitApiDocs = "visit:api-docs",

  visitSavingsSuggestions = "visit:savingsSuggestions",

  visitWorkflowAdd = "visit:workflow-add",
  visitWorkflows = "visit:visitWorkflows",
  visitWorkflowDetails = "visit:visitWorkflowDetails",

  visitKpi = "visit:kpi",

  visitThresholds = "visit:thresholds",
}

enum ACTIONS_VIEW {
  viewNotifications = "view:notifications",
  viewSearchBox = "view:search-box",
  viewDefaultApplication = "view:default-application",
  viewDashboardCharts = "view:dashboard-charts",
  viewWorkflowKpis = "view:workflow-kpis",
  viewEnvironmentKpi = "view:environment-kpi",
  viewUtilizationTab = "view:utilization-tab",
}

enum ACTIONS_UPDATE {
  updateApplication = "update:application",
  updateApplicationOwner = "update:application-owner",
  updateMapping = "update:mapping",
  updateDiscoveryRules = "update:discovery-rules",
  updateSavingsSuggestions = "update:savingsSuggestions",
  updateWorkflow = "update:workflow",
  updateEnvironment = "update:environment",
  updateBudget = "update:budget",
  updatePerson = "update:person",
}

enum ACTIONS_ADD {
  addApplication = "add:application",
  addEnvironment = "add:environment",
  addOrgUnit = "add:org-unit",
  addPerson = "add:person",
}

enum ACTIONS_REMOVE {
  removeApplication = "remove:application",
  removeEnvironment = "remove:environment",
  removePerson = "remove:person",
}

export const ACTIONS = {
  ...ACTIONS_VIEW,
  ...ACTIONS_VISIT,
  ...ACTIONS_UPDATE,
  ...ACTIONS_ADD,
  ...ACTIONS_REMOVE,
} as const;

export type ACTION = (typeof ACTIONS)[keyof typeof ACTIONS];
